import React from 'react';
import { Form, Card, Button, Spinner } from 'react-bootstrap';
import { useUploadFile } from '../../../../../api/fileUpload/fileUpload.hooks';

const AboutEditor = ({ about, onChange }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onChange({ ...about, [field]: value });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const result = await upload(file);
      handleChange('image', result.url);
    } catch (err) {
      console.error('Upload failed:', err);
    }
  };

  const handleHighlightChange = (index, value) => {
    const newHighlights = [...about.highlights];
    newHighlights[index] = value;
    onChange({ ...about, highlights: newHighlights });
  };

  const addHighlight = () => {
    onChange({ ...about, highlights: [...about.highlights, ''] });
  };

  const removeHighlight = (index) => {
    const newHighlights = about.highlights.filter((_, i) => i !== index);
    onChange({ ...about, highlights: newHighlights });
  };

  return (
    <Card className="mb-3">
      <Card.Header className='bg-neutral-gray'>
        <h5 className="mb-0">About Us Section</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Heading</Form.Label>
          <Form.Control
            type="text"
            value={about.heading}
            onChange={(e) => handleChange('heading', e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Paragraph</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={about.paragraph}
            onChange={(e) => handleChange('paragraph', e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Image</Form.Label>
          <div>
            {about.image ? (
              <div className="position-relative d-inline-block">
                <img
                  src={about.image}
                  alt="About"
                  style={{ width: '300px', height: '200px', objectFit: 'cover', borderRadius: '4px' }}
                />
                <Button
                  variant="danger"
                  size="sm"
                  className="position-absolute top-0 end-0"
                  style={{ transform: 'translate(50%, -50%)' }}
                  onClick={() => handleChange('image', '')}
                >
                  <i className="fa fa-times"></i>
                </Button>
              </div>
            ) : (
              <Button
                variant="outline-primary"
                as="label"
                disabled={isUploading}
              >
                {isUploading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-1" />
                    Uploading...
                  </>
                ) : (
                  <>
                    <i className="fa fa-upload me-1"></i> Upload Image
                  </>
                )}
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </Button>
            )}
          </div>
        </Form.Group>

        <div>
          <h6 className="mb-3">Highlights</h6>
          {about.highlights.map((highlight, index) => (
            <div key={index} className="mb-2 d-flex gap-2">
              <Form.Control
                type="text"
                value={highlight}
                onChange={(e) => handleHighlightChange(index, e.target.value)}
              />
              <Button variant="danger" size="sm" onClick={() => removeHighlight(index)}>
                <i className="fa fa-trash"></i>
              </Button>
            </div>
          ))}
          <Button variant="outline-primary" size="sm" onClick={addHighlight}>
            <i className="fa fa-plus me-1"></i> Add Highlight
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default AboutEditor;
